const WORDS = [
    "Tanjore Paintings",
    "Vintage Scooters",
    "Rare Artefacts",
    "Sari Dress-Up",
    "Nagarathar Heritage",
    "Living History",
];

const Row = ({ hidden }) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
        {WORDS.map((w) => (
            <span key={w} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-heritage-sand md:text-3xl">
                    {w}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-heritage-gold/70" />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="overflow-hidden border-y border-heritage-gold/20 bg-heritage-terra py-5"
    >
        <div className="animate-ihcc-marquee flex w-max">
            <Row hidden={false} />
            <Row hidden />
        </div>
    </div>
);

export default Marquee;
